module.exports = __webpack_public_path__ + "fonts/MyriadPro-Bold.26a8e3a.woff2";